import {Label} from "@/components/ui/label";
import React from "react";
import {Notice} from "@/model/alarm/Notice";
import NoticeHistory from "@/view/alarm/NoticeHistory";
import useNoticeHistory from "@/query/alarm/useNoticeHistory";


const NoticeHistoryListView = () => {
    const {data: noticeHistories} = useNoticeHistory();

    return (
        <div className="flex flex-col gap-3">
            <Label htmlFor="noticeHisotry">Notice History</Label>
            {noticeHistories && noticeHistories.length > 0 ? (
                noticeHistories.map((notice: Notice) => (
                    <NoticeHistory key={notice._id} notice={notice} />
                ))
            ) : (
                <div>Empty History</div>
            )}
        </div>
    )
}

export default NoticeHistoryListView;